module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl edmodo-footer-lang"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "widget_text fusion-footer-widget-column widget widget_custom_html",
    attrs: {
      "id": "custom_html-2"
    }
  }, [_c('div', {
    staticClass: "textwidget"
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(this.$t('txt_0037'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "edmodo",
    domProps: {
      "textContent": _vm._s('Edmodo © ' + _vm.year)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fusion-footer-widget-column widget widget_media_image"
  }, [_c('img', {
    staticClass: "image wp-image-1533  attachment-full size-full",
    staticStyle: {
      "max-width": "100%",
      "height": "auto"
    },
    attrs: {
      "width": "250",
      "height": "54",
      "src": "https://9kyhf3crb4ah2d0m726aoc6x-wpengine.netdna-ssl.com/wp-content/uploads/2019/06/hybridArtboard-5@2x.png",
      "alt": "",
      "srcset": "https://9kyhf3crb4ah2d0m726aoc6x-wpengine.netdna-ssl.com/wp-content/uploads/2019/06/hybridArtboard-5@2x-200x43.png 200w, https://9kyhf3crb4ah2d0m726aoc6x-wpengine.netdna-ssl.com/wp-content/uploads/2019/06/hybridArtboard-5@2x.png 250w",
      "sizes": "(max-width: 250px) 100vw, 250px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1723b4d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edmodo/footer/lang.vue
// module id = 465
// module chunks = 9